import React from 'react';
import Modal from '../Modal2';
import t from '../../i18n/I18n';
import KeyboardShortcuts from '../../keyboard-shortcuts/KeyboardShortcuts';
import KeydownConfig from '../../keyboard-shortcuts/KeydownConfig';
import { KeyCode } from '../../util/Constants';

type Props = {
  onClose: Function,
  moveAsset: Function,
  message: String,
  onCross: Function
};

export default class ConfirmModal extends React.Component<Props> {
  static defaultProps = {
    moveAsset: _.noop,
    title: t('CONFIRM')
  };
  componentDidMount() {
    KeyboardShortcuts.add(new KeydownConfig('CONFIRM_MODAL', this.onEnterKey, [KeyCode.ENTER]));
  }
  componentWillUnmount() {
    KeyboardShortcuts.remove('CONFIRM_MODAL');
  }

  render() {
    const { onClose, message, title, moveAsset, onCross } = this.props;

    const modalProps = {
      name: 'Confirm',
      title: title,
      onClose,
      buttons: [
        { label: t('NO'), type: 'CANCEL', onClick: onClose },
        { label: t('YES'), type: 'PRIMARY', onClick: moveAsset }
      ]
    };

    return (
      <Modal {...modalProps} closeOnEsc={true} onCross={onCross} closeOnOutsideClick={true}>
        <div>{message}</div>
      </Modal>
    );
  }
  onEnterKey = () => {
    this.props.moveAsset();
  };
}
const styles = {
  asset: {
    width: '100%',
    background: 'var(--primary-header-bg)',
    color: 'var(--primary-font-color)',
    padding: '5px',
    display: 'flex',
    boxShadow: '0 1px 4px 0 rgba(0,0,0,0.04)',
    cursor: 'pointer',
    fontSize: '14px',
    marginBottom: '15px'
  }
};
